export const LINKS = {
  ABOUT: { label: 'About', href: '#about' },
  PLATFORM: { label: 'Platform', href: '#platform' },
  PARTNERS: { label: 'Partners', href: '#partners' },
  CONTACT: { label: 'Contact', href: '#contact' },
  NEWS: { label: 'News', href: 'https://www.linkedin.com/company/opensesamemedia/posts/' },
};
